import Proxy from './Proxy'

class PopularDealsMetricsProxy extends Proxy {
  /**
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super(`${process.env.CLO_PHP_API_ENV}_stats/popular_deals`, parameters)
  }
}

export default PopularDealsMetricsProxy



// WEBPACK FOOTER //
// ./src/app/proxies/PopularDealsMetricsProxy.js